// extracted by mini-css-extract-plugin
module.exports = {"arrow":"timeline-navigation_arrow__OCP_7","nav":"timeline-navigation_nav__oCowy","navButton":"timeline-navigation_navButton__SRGqY"};